import type {ExtendedPromise, OttoNexus} from "@otto-ec/global-resources/nexus";
import {apps} from "../index.js";

export type NativeAppEvent = {
    /**
 *
 */
    name: string;
    /**
 *
 */
    timestamp: Date;
}

export type GlobalRaw = {
    /**
 *
 */
    retrieveNativeAppEvents(): ExtendedPromise<NativeAppEvent[]>;
}

export type AppsGlobal = OttoNexus["apps"]["global"]

/**
 *
 */
export const global: AppsGlobal = apps.global;

/**
 *
 */
export const retrieveNativeAppEvents: AppsGlobal["retrieveNativeAppEvents"] = global.retrieveNativeAppEvents;